import { Box, Tab, Tabs, Typography } from "@mui/material";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../assets/styles/tokens";
import ClickandImpressionFilter from "./ClickandImpressionFilter";
import React from "react";
import ClickandImpressionSingleChart from "./ClickandImpressionSingleChart";
import ClickandImpressionMultipleChart from "./ClickandImpressionMultipleChart";

const ClickandImpression = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ px: 2 }}>
      <Typography variant="subtitle1" fontWeight={typography.Font_weight.Medium.$value} mb={1}>
        Trends Details
      </Typography>

      <Tabs
        value={value}
        onChange={handleChange}
        centered
        sx={{
          "& .MuiTabs-scrollButtons": {
            color: colors.GrayDarkMode[700].$value,
          },
          background: colors.GrayLightMode[100].$value,
          borderTop: "2px solid" + colors.GrayLightMode[100].$value,
          borderBottom: "2px solid" + colors.GrayLightMode[100].$value,
          borderRadius: spacing.Radius.md.$value,
          minHeight: spacing.Spacing["3xl"].$value,
          lineHeight: typography.Line_height.text.xs.$value,
          mb: 1,
        }}
        TabIndicatorProps={{
          sx: {
            height: spacing.Spacing.none.$value,
          },
        }}
      >
        {["Action Date", "Click Date"].map((label) => (
          <Tab
            key={label}
            label={label}
            disableRipple
            sx={{
              width: "49.3%",
              color: colors.GrayLightMode[500].$value,
              textTransform: "none",
              fontWeight: typography.Font_weight.Medium.$value,
              borderRadius: spacing.Radius.xs.$value,
              fontSize: typography.Size.Text.xs.$value,
              padding: 0,
              minHeight: spacing.Spacing["3xl"].$value,
              "&.Mui-selected": {
                color: colors.GrayLightMode[900].$value,
                fontWeight: typography.Font_weight.Bold.$value,
                backgroundColor: colors.Base.White.$value + "!important",
              },
              "&:hover": { backgroundColor: "transparent" },
            }}
          />
        ))}
      </Tabs>

      <ClickandImpressionFilter />
      <ClickandImpressionSingleChart />
      <ClickandImpressionMultipleChart />
    </Box>
  );
};

export default ClickandImpression;
